import { render, staticRenderFns } from "./NewShipBluTable.vue?vue&type=template&id=04b7ab93"
import script from "./NewShipBluTable.vue?vue&type=script&lang=js"
export * from "./NewShipBluTable.vue?vue&type=script&lang=js"
import style0 from "./NewShipBluTable.vue?vue&type=style&index=0&id=04b7ab93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports